<mat-toolbar class="footer">
  <span>
    Todos os direitos reservados
  </span>
</mat-toolbar>
